import { compose, withState, withHandlers } from 'recompose'

export default compose(
  withState('activeTooltip', 'setTooltip', null),
  // we use normal handlers to call setTooltip so that we don't
  // have to use anonymous functions in our component.
  // otherwise, component must have: `onClick={() => setTooltip('ex')}`
  // these let us do: `onClick={handleOpenTooltip('ex')}`
  withHandlers({
    handleOpenTooltip: props => tooltipId => () => props.setTooltip(tooltipId),
    handleCloseTooltip: props => () => {
      props.setTooltip(null)
    },
  }),
)
